import advisorsService from "../services/advisors.service";
import { SET_ADVISOR_EARNINGS, SET_ADVISOR_METRIX, SET_CURRENT_USER, SET_PAYOUT_LIST, SET_RANKING_LIST, SET_TOP_THREE_RANK } from "./types";

export const getEarningsAction = () => async (dispatch) => {
    return await advisorsService.getEarning().then((resp) => {
        dispatch({ type: SET_ADVISOR_EARNINGS, payload: resp.data || 0 });
    });
};

export const getRankingListAction = (page, limit) => async (dispatch) => {
    return await advisorsService.getRankingList(page, limit).then((resp) => {
        dispatch({ type: SET_RANKING_LIST, payload: resp?.data || [], count: resp?.count });
        if (page === 1) {
            dispatch({ type: SET_TOP_THREE_RANK, payload: resp?.topThreeAdvisors || [] });
            dispatch({ type: SET_CURRENT_USER, payload: resp?.currentUser || [] });
        }
    });
};


export const getPayoutListAction = (page, limit, status) => async (dispatch) => {
    return await advisorsService.getPayoutsList(page, limit, status).then((resp) => {
        dispatch({ type: SET_PAYOUT_LIST, payload: resp?.data || [], count: resp?.count });
    });
};

export const getAdvisorMertrixAction = () => async (dispatch) => {
    return await advisorsService.getAdvisorMertrix().then((resp) => {
        dispatch({ type: SET_ADVISOR_METRIX, payload: resp?.data || [] });
    });
};

export const validateInputAction = (payload) => async () => {
    const resp = await advisorsService.validateInput(payload);
    if (resp.status) {
        return resp.data;
    }
    return resp;
};
